<template>
  <div class="chart">
    <div class="bt">
<!--      <el-button type="primary" @click="dialogVisible=true">开始对话</el-button>-->
      <el-button icon="el-icon-full-screen" circle @click="dialogVisible=true"></el-button>
    </div>
    <div class="chart-context">
      <div class="reasoning" ref="reasoningRef">{{reasoning}}</div>
      <div class="content2" v-html="reader_content" ref="contentRef"></div>
    </div>
    <el-dialog class="dialog" :visible.sync="dialogVisible" width="80vh" append-to-body>
      <div class="chart-content" v-if="dialogVisible">
        <div v-html="reader_content"></div>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import AgentApp from "../../common/AgentApp";
import {CommonHelp} from "../../common/CommonHelp";

let md=null;
let reader_data="";
export default {
  name: "AIChart",
  data(){
    return {
      dialogVisible:false,
      chartData: [],
      content:"",
      reader_content:"",
      reasoning: "",
    };
  },
  mounted() {
    CommonHelp.loadJs("https://cdn.bootcdn.net/ajax/libs/marked/16.3.0/lib/marked.umd.js",()=>{
      console.log("commonmark.js")
      md = window.marked;
    })
  },
  methods: {
    show(messages=[]){
      const that=this;
      that.content="";
      that.reader_content="";
      that.reasoning="";
      reader_data="";
      if(!md){
        md = window.marked
      }
      //https://meter.gdzawy.com/chatApi/ChatApp/getList
      AgentApp.getInstance().onChart("https://meter.gdzawy.com/chatApi/AgentApp/apiStream",{
        messages:messages,
        //   [
        //   { role: 'user', content: "你好，很高兴认识你！" }
        // ],
      },content=>{
        // console.log(content);
        reader_data += content;
        that.renderContent();
        that.$refs.contentRef.scrollTop = that.$refs.contentRef.scrollHeight;
      },reasoning=>{
        that.reasoning += reasoning;
        that.$refs.reasoningRef.scrollTop = that.$refs.reasoningRef.scrollHeight;
        // console.log(reasoning);
      }).then();
    },
    renderContent(){
      const that=this;
      that.reader_content = md.parse(reader_data);
    },
    cancel(){
      AgentApp.getInstance().cancel().then(r=>{})
    }
  },
  unmounted() {
    this.cancel()
    this.content="";
    this.reader_content="";
    this.reasoning="";
    reader_data="";
  }
}
</script>

<style lang="scss" scoped>
.chart{
  height: 100%;
  position: relative;

  .bt{
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .chart-context{
    height: 100%;
    //overflow-y: scroll;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 5px;

    .reasoning{
      height: 100px;
      overflow-y: scroll;
      transition: all 20ms ease-in-out;
      padding: 5px;
      border: 1px solid #EEEEEE;
      border-radius: 5px;
      color: #999999;
    }
    .content2{
      height: calc(100% - 100px);
      overflow-y: scroll;
      transition: all 20ms ease-in-out;
      padding-top: 5px;
    }
  }




}
.dialog{
  >>> .chart-content{
    height: 60vh;
    width: 100%;
    overflow-y: scroll;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/ai/AIChart.vue